module.exports = __webpack_public_path__ + "static/media/bigbuddah1.ae71bd9a.jpg";